export const selectTopicsState = (state) => state.topics;
